import React from "react";
import { Flame } from "lucide-react";

/**
 * MashFactorBanner — the criterion banner shown above each matchup.
 * Two sizes: "sm" for in-game headers, "lg" for start/results screens.
 */
export const MashFactorBanner = ({ label, size = "sm", testId = "mash-factor-banner" }) => {
  if (!label) return null;
  const isLarge = size === "lg";
  return (
    <div
      data-testid={testId}
      className={`relative rounded-2xl border overflow-hidden ${
        isLarge
          ? "border-[#FF107A]/50 bg-gradient-to-br from-[#FF107A]/15 via-[#A855F7]/10 to-[#00E5FF]/10 p-4"
          : "border-[#FF107A]/40 bg-[#FF107A]/8 p-2.5"
      }`}
    >
      <div className="absolute inset-0 halftone opacity-15 pointer-events-none" />
      <div className="relative flex items-center gap-2">
        <div
          className={`shrink-0 rounded-lg flex items-center justify-center text-[#FF107A] bg-[#FF107A]/15 border border-[#FF107A]/30 ${
            isLarge ? "w-9 h-9" : "w-7 h-7"
          }`}
          aria-hidden
        >
          <Flame size={isLarge ? 16 : 12} strokeWidth={2.5} />
        </div>
        <div className="min-w-0 flex-1">
          <div className={`tracking-[0.3em] uppercase font-bold text-[#FF107A] ${isLarge ? "text-[10px]" : "text-[9px]"}`}>
            Mash Factor
          </div>
          <div
            data-testid={`${testId}-label`}
            className={`font-display leading-tight tracking-tight text-[#FDFBF7] ${
              isLarge ? "text-xl sm:text-2xl mt-0.5" : "text-sm mt-0.5 truncate"
            }`}
          >
            {label}
          </div>
        </div>
      </div>
    </div>
  );
};
